<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">业务基础信息管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>孤寡老人基本管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="姓名">
                <el-input
                  v-model="form.xm"
                  clearable
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="请选择社区"
                  clearable
                  v-model="form.sq"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.code"
                     :label="item.pointName"
                     :value="item.pointName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="身份证号">
                <el-input
                  v-model="form.sfzh"
                  clearable
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="联系电话">
                <el-input
                  v-model="form.lxdh"
                  clearable
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="居住地址">
                <el-input
                  v-model="form.zjdz"
                  clearable
                  placeholder="请输入居住地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="启停标识">
                <el-select
                  filterable
                  placeholder="请选择启停标识"
                  clearable
                  v-model="form.commonRunState"
                >
                  <el-option
                    v-for="item in sfyjsxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn">

          </div>
          <div class="right-btn">
            <!-- <el-button class="other el-icon-download" @click="downloadFileFun"
              >模板下载</el-button
            >
            <el-upload
              class="upload-demo"
              accept=".xlsx"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="importDataFun"
            >
              <el-button class="other el-icon-upload2">数据导入</el-button>
            </el-upload> -->

            <el-button @click="addDialogFun({}, 1)" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="true"
          :page="page"
          :dataList="dataList"
          :selectedIdOptions="selectedIdOptions"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          @handleSelectionChange="handleSelectionChange"
          @selectAll="selectAll"
        >
          <template v-slot:commonRunState="{ scope }">
            <el-switch
              @change="
                value => {
                  extendGglrRkEdit(value, scope.row);
                }
              "
              v-model="scope.row.commonRunState"
              active-value="ANY"
              inactive-value="CLOSE"
              active-color="#0495FF"
            >
            </el-switch>
            <!-- <span>
              {{ scope.row.commonRunState }}
            </span> -->
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row, 2)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >编辑</el-button
            >

          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
      :titleName="titleName"
      :commcommunityList="commcommunityList"
      @refreshList="indexPageFun"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  extendGglrRkPage,
  extendGglrRkEdit
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import addDialog from "./components/addDialog.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import index from "@/mixins/index.js";
export default {
  components: {
    commonTable,
    addDialog
  },
  mixins: [index, pageChangeSelect],
  data() {
    return {
      form: {
        xm: "",
        sq: "",
        sfzh: "",
        lxdh: "",
        zjdz: "",
        commonRunState: ""
      },
      sfyjsxOptions: [
        {
          label: "ANY",
          value: "ANY"
        },
        {
          label: "CLOSE",
          value: "CLOSE"
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "xm",
            label: "姓名"
          },
          {
            prop: "sq",
            label: "社区"
          },
          {
            prop: "nl",
            label: "年龄"
          },
          {
            prop: "sfzh",
            label: "身份证号"
          },
          {
            prop: "lxdh",
            label: "联系电话"
          },
          {
            prop: "jzdz",
            label: "居住地址"
          },
          {
            prop: "hjdz",
            label: "户籍地址"
          },
          {
            prop: "dylxr",
            label: "第一联系人"
          },
          {
            prop: "posfjz",
            label: "配偶是否健在"
          },
          {
            prop: "sfypoyqjz",
            label: "是否与配偶居住"
          },
          {
            prop: "poxx",
            label: "配偶信息"
          },
          {
            prop: "sfybm",
            label: "是否有保姆"
          },
          {
            prop: "bmlxfsjdz",
            label: "保姆联系方式及住址"
          },
          {
            slot: "commonRunState",
            label: "启停标识",
            width: 120
          },
          {
            slot: "operation",
            label: "操作",
            width: 120
          }
        ]
      },
      curItem: {},
      typeList: [],
      titleName: '新增'
    };
  },
  mounted() {
    if (this.$route.query) {
      this.form.ghEventTypeId = this.$route.query.ghEventTypeId;
      this.form.sxmc = this.$route.query.sxmc;
    }
    this.getCommcommunityAllFun();
    this.extendGglrRkPage();
  },
  methods: {
    indexPageFun() {
      this.extendGglrRkPage();
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    addDialogFun(item, type) {
      this.titleName = '新增'
      if (type == 2) {
        this.titleName = '编辑'
      }
      this.dialogVisible = true;
      this.curItem = {
        ...item,
        type
      };
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.extendGglrRkPage();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.extendGglrRkPage();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.extendGglrRkPage();
    },
    onReset() {
      this.form.xm = "";
      this.form.sq = "";
      this.form.sfzh = "";
      this.form.lxdh = "";
      this.form.zjdz = "";
      this.form.commonRunState = "";
      this.page.page = 1;
      this.page.size = 10;
      this.extendGglrRkPage();
    },
    async selListFun() {
      const res = await selList({});
      this.typeList = res.data.data || [];
    },
    async copyIndexFun(id) {
      const res = await copyIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "复制成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delIndexFun(id) {
      const res = await delIndex({
        id: id
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.extendGglrRkPage();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async delBatchIndexFun(id) {
      const res = await delBatchIndex({
        ids: this.selectedIdOptions
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.onSearch();
        this.selectedIdOptions = [];
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    async extendGglrRkEdit(value, item) {
      const res = await extendGglrRkEdit({
        ...item,
        commonRunState: value
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.extendGglrRkPage();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 分页查询
    async extendGglrRkPage() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await extendGglrRkPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/elderlyPeopleLliving/index.vue